<style lang="stylus">
    body
        display: flex
        flex-direction: column
        min-height: 100vh
</style>

<style lang="stylus">
    $bg = #009ee7
    $textColor = #828080
    .sets-footer
        background-color: $bg
        margin-top: 60px

        > .footer-inner
            padding: 10px 0
            color: #bee3ff
            background-color: $bg
            min-width: 1200px
            text-align: center
            a
                color: #cfeffe
                &:hover
                    color darken(#cfeffe, 20%)
        &.company-home
            margin-top 120px
            .footer-inner-sib
                height 100px
                background-color #333
                .sib-inner
                    width 1200px
                    margin auto
                    .logo
                        cursor: pointer
                        margin-top 30px
                        display: inline-block
                        img
                            height: 40px
                    .page-link
                        margin-top 42px
                        display inline-block
                        a
                            color: $textColor
                            margin-left 40px
                            &:hover
                                color lighten($textColor, 20%)
                    .page-tip
                        margin-top 42px
                        display inline-block
                        float right
                        color $textColor
                        a
                            color $textColor
                            &:hover
                                color darken($textColor, 20%)
            .footer-inner
                background-color #333
                color $textColor

</style>

<template>
    <div style="flex: 1"></div>
    <div class="sets-footer hidden-print" :class="{'company-home':currentPageType==PageType.HOME}">
        <div v-if="currentPageType==PageType.HOME" class="footer-inner-sib">
            <div class="sib-inner">
                <div class="logo">
                    <!--<a href=""><img :src="company.companyLogo"/></a>-->
                </div>
                <div class="page-link">
                    <a href="/e" style="margin-left:5px">考试入口</a>
                    <a href="/store/open/resource">试题资源</a>
                    <a href="/settings/basic-info">个人设置</a>
                </div>
                <div class="page-tip">
                    {{company.displayCopyright ? 'Copyright©' + nowYear : ''}} {{company.companyName}}&emsp;{{{icp}}}&emsp;{{{psp}}}
                </div>
            </div>
        </div>
        <div v-else class="footer-inner">
            <p v-if="isCompanyDomain">
                {{company.displayCopyright ? 'Copyright©' + nowYear : ''}} {{company.companyName}}&emsp;{{{icp}}}&emsp;{{{psp}}}
            </p>
            <p v-else>
              Copyright©{{nowYear}} 亚信科技（中国）有限公司&emsp;<img src="https://www.beian.gov.cn/img/new/gongan.png"/><a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802041850" target="_blank">京公网安备 11010802041850号</a>&emsp;<a href="http://beian.miit.gov.cn" target="_blank">京ICP备 11005544号-16</a>
            </p>
        </div>
    </div>
</template>

<script>
    /**
     * Footer
     */
    import { env, company, params, request } from 'bootsets/runtime'
    import { PageType } from 'core/constant'
    export default{
        data() {
            return {
                company,
                PageType,
                isCompanyDomain: env.isCompanyDomain,
                icp: '',
                psp: '',
                currentPageType: +params.pageType || +request.pageType || '',
            }
        },
        computed: {
            nowYear() {
                return new Date().getFullYear()
            }
        },
        ready() {
            this.icp = company.contentObj ? company.contentObj.icp : ''
            this.psp = company.contentObj ? company.contentObj.psp : ''
        }
    }

</script>



// WEBPACK FOOTER //
// sets-footer.vue?3ab35cdb